import https, { https_ } from './httpsService'
import * as api from './api'
import { checkToken } from '../helpers/commonHelpers';
import {
    ClientReview,
    BusPassReportFormValues,
    UpdateAppointmentTimeFormValues,
} from '../types';
let v1 = '/api/v1';

const reportPreviewUrl = `${v1}/ReportConfiguration/preview`;
export async function getReportExclusionSummary(reportId: number, configVersionId: number | null | undefined,
    artifactId: string | undefined, metricId: string | undefined, page: number, signal: AbortSignal) {
    const url = artifactId
        ? `${reportPreviewUrl}/artifacts/${encodeURIComponent(artifactId)}/excluded-record-summary`
        : `${v1}${api.REPORT_CONFIGURATION_REPORT_WORKBOOK}/${reportId}/excluded-record-summary`;
    return (await https.get(url, { params: { configVersionId, metricId, page, pageSize: 20 }, signal, timeout: 250000 })).data;
}
export async function getReportPreviewCatalog(params: Record<string, unknown>, signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/reports`, { params, signal })).data;
}
export async function getReportPreviewFolders(signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/folders`, { signal })).data;
}
export async function getReportPreviewDetails(reportId: number, signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/reports/${reportId}`, { signal })).data;
}
export async function createReportPreview(reportId: number, signal: AbortSignal) {
    return (await https.post(`${reportPreviewUrl}/reports/${reportId}`, {}, { signal, timeout: 250000 })).data;
}
export async function getReportPreviewGridPage(id: string, index: number, section: number, page: number, pageSize: number, signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/artifacts/${encodeURIComponent(id)}/sheets/${index}/grid/sections/${section}`, { params: { page, pageSize }, signal, timeout: 60000 })).data;
}
export async function getReportPreviewGrid(id: string, index: number, signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/artifacts/${encodeURIComponent(id)}/sheets/${index}/grid`, { signal, timeout: 60000 })).data;
}
export async function downloadReportPreview(id: string, signal: AbortSignal) {
    return (await https.get(`${reportPreviewUrl}/artifacts/${encodeURIComponent(id)}/workbook`, { signal, responseType: "blob", timeout: 900000 })).data;
}

export async function getGrievances() {

    let res = await https.get("/api/v1/grievances")
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function createGrievanceCall(formData: any, type: string, cb: any, id?: any) {

    let request: any = type == 'POST' ? https_.post : https_.put
    try {
        const url = type == "POST" ? `api/v1/grievances` : `api/v1/grievances`;
        let res = await request(`${url}`, formData, { timeout: 50000 })
        cb(res)
    }
    catch (err) {
        if (err?.response?.data && err?.response?.data?.messages.length) {
            cb({ hasError: true, error: err?.response?.data?.messages[0].description ?? "Please Add Required Fields" })
        }
        else {
            cb({ hasError: true, error: null })
        }
    }

}

export async function search(data: any, cb: any) {

    let res = await https.post(v1 + api.GRIEVANCES_SEARCH, data, { timeout: 50000 })
        // let res = await https.post('https://ccerrtsnet6api-dev.azurewebsites.net/api/v1/grievances/search',data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
}

export async function complaintSearch(data: any, cb: any) {

    let res = await https.post(v1 + api.COMPLAINT_SEARCH, data, { timeout: 50000 })
        // let res = await https.post('https://ccerrtsnet6api-dev.azurewebsites.net/api/v1/grievances/search',data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
}

export async function legalSearch(data: any, cb: (response: any) => void) {
    try {
        let res = await https.post(v1 + api.LEGAL_SEARCH, data, { timeout: 50000 });
        cb(res.data);
    } catch (err) {
        console.error("Error fetching legal search results:", err);
        cb("error");
    }
}

export function exportAllComplaint(data: any, cb: any) {

    let res = https.post(v1 + api.EMPLOYEES_GetExportList, data, { timeout: 5000000 });
}

export async function getEmployees(searchText: string) {
    let res = await https.post(v1 + api.EMPLOYEES_SEARCH, { searchText: searchText, pageIndex: 0, pageSize: 100, designationIds: [2001, 2002], considerAll: false })
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}
export async function getAganistType() {
    let res = await https.get('api/v1/Grievances/GetAgainstType')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getSourceType() {
    let res = await https.get('api/v1/Grievances/GetSourceType')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getComplaintStatus() {
    let res = await https.get('api/v1/Complaints/GetComplaintStatuses')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}
export async function clientReview(data: ClientReview, cb: (arg: string) => void) {
    https.put(v1 + api.CLIENT_REVIEW, data)
        .then((res) => cb('success'))
        .catch((err) => cb('error'))
        .finally(() => cb('complete'))

}

export async function getClients() {

    let res = await https.get(v1 + api.CLIENTS)
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getReportConfigurationClients() {
    try {
        const response = await https.get(v1 + api.REPORT_CONFIGURATION_CLIENTS)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationLookups(clientId?: number) {
    try {
        const url = v1 + api.REPORT_CONFIGURATION_LOOKUPS
        const response = clientId
            ? await https.get(url, { params: { clientId }, timeout: 60000 })
            : await https.get(url, { timeout: 60000 })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationDataModels() {
    try {
        const response = await https.get(v1 + api.REPORT_CONFIGURATION_DATA_MODELS)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationRuleOperators() {
    try {
        const response = await https.get(v1 + api.REPORT_CONFIGURATION_RULE_OPERATORS)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationExcelLayoutTemplates(
    dataModelId: number,
    dataModelColumnId: number,
    displayAs?: string,
    options?: { reportId?: number | null; scope?: "global" | "report" },
) {
    try {
        const response = await https.get(v1 + api.REPORT_CONFIGURATION_EXCEL_LAYOUT_TEMPLATES, {
            params: {
                dataModelId,
                dataModelColumnId,
                ...(displayAs ? { displayAs } : {}),
                ...(options?.reportId ? { reportId: options.reportId } : {}),
                ...(options?.scope ? { scope: options.scope } : {}),
            }
        })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function createReportConfigurationExcelLayoutTemplate(payload: unknown) {
    try {
        const response = await https.post(v1 + api.REPORT_CONFIGURATION_EXCEL_LAYOUT_TEMPLATES, payload)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function updateReportConfigurationExcelLayoutTemplate(templateId: number, payload: unknown) {
    try {
        const response = await https.put(`${v1}${api.REPORT_CONFIGURATION_EXCEL_LAYOUT_TEMPLATES}/${templateId}`, payload)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function deleteReportConfigurationExcelLayoutTemplate(templateId: number) {
    try {
        const response = await https.delete(`${v1}${api.REPORT_CONFIGURATION_EXCEL_LAYOUT_TEMPLATES}/${templateId}`)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationReportPlan(clientId: number, signal?: AbortSignal) {
    try {
        const response = await https.get(`${v1}${api.REPORT_CONFIGURATION_REPORT_PLAN}/${clientId}/report-plan`, { signal, timeout: 60000 })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function createReportConfigurationFolder(reportPlanId: number, label: string) {
    try {
        const response = await https.post(v1 + api.REPORT_CONFIGURATION_REPORT_FOLDERS, { reportPlanId, label })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function updateReportConfigurationFolder(reportFolderId: number, label: string) {
    try {
        const response = await https.put(`${v1}${api.REPORT_CONFIGURATION_REPORT_FOLDERS}/${reportFolderId}`, { reportPlanId: 0, label })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function deleteReportConfigurationFolder(reportFolderId: number) {
    try {
        const response = await https.delete(`${v1}${api.REPORT_CONFIGURATION_REPORT_FOLDERS}/${reportFolderId}`)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function createReportConfigurationReport(reportFolderId: number, label: string) {
    try {
        const response = await https.post(v1 + api.REPORT_CONFIGURATION_REPORTS, { reportFolderId, label })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function updateReportConfigurationReport(reportId: number, label: string) {
    try {
        const response = await https.put(`${v1}${api.REPORT_CONFIGURATION_REPORTS}/${reportId}`, { reportFolderId: 0, label })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function deleteReportConfigurationReport(reportId: number) {
    try {
        const response = await https.delete(`${v1}${api.REPORT_CONFIGURATION_REPORTS}/${reportId}`)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function cloneReportConfigurationReport(reportId: number, payload: { newReportName: string; newClientId: number; newFolderId: number }) {
    try {
        const response = await https.post(`${v1}${api.REPORT_CONFIGURATION_REPORTS}/${reportId}/clone`, payload)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationConfigVersions(reportId: number, signal?: AbortSignal) {
    try {
        const response = await https.get(`${v1}${api.REPORT_CONFIGURATION_REPORTS}/${reportId}/config-versions`, { signal, timeout: 60000 })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationConfigVersion(configVersionId: number, signal?: AbortSignal) {
    try {
        const response = await https.get(`${v1}${api.REPORT_CONFIGURATION_CONFIG_VERSIONS}/${configVersionId}`, { signal, timeout: 60000 })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function saveReportConfigurationConfig(payload: unknown) {
    try {
        const response = await https.post(v1 + api.REPORT_CONFIGURATION_CONFIG_VERSIONS, payload)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function updateReportConfigurationConfig(configVersionId: number, payload: unknown) {
    try {
        const response = await https.put(`${v1}${api.REPORT_CONFIGURATION_CONFIG_VERSIONS}/${configVersionId}`, payload)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function generateReportConfigurationWorkbook(reportId: number, configVersionId?: number | null) {
    try {
        const url = `${v1}${api.REPORT_CONFIGURATION_REPORT_WORKBOOK}/${reportId}/workbook`
        const response = await https.get(url, {
            responseType: "blob",
            timeout: 3600000,
            ...(configVersionId ? { params: { configVersionId } } : {}),
        })
        return response
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export const prepareReportWorkbookDownload = (reportId: number, configVersionId: number | null | undefined, signal: AbortSignal) =>
    https.post(`${v1}/ReportConfiguration/reports/${reportId}/workbook-downloads`, null,
        { params: { configVersionId }, signal, timeout: 45000 });

export const getReportWorkbookDownloadStatus = (jobId: string, signal: AbortSignal) =>
    https.get(`${v1}/ReportConfiguration/workbook-downloads/${encodeURIComponent(jobId)}`, { signal, timeout: 45000 });

export const getPreparedReportWorkbookChunk = (jobId: string, start: number, end: number, signal: AbortSignal) =>
    https.get(`${v1}/ReportConfiguration/workbook-downloads/${encodeURIComponent(jobId)}/file`,
        { signal, responseType: "blob", timeout: 90000, headers: { Range: `bytes=${start}-${end}` } });

export async function generateReportConfigurationExcludedRecordsWorkbook(reportId: number, configVersionId?: number | null, onDownloadProgress?: (loadedBytes: number) => void) {
    try {
        const url = `${v1}${api.REPORT_CONFIGURATION_REPORT_WORKBOOK}/${reportId}/excluded-records-workbook`
        const response = await https.get(url, {
            responseType: "blob",
            timeout: 3600000,
            ...(onDownloadProgress ? { onDownloadProgress: (event: { loaded: number }) => onDownloadProgress(event.loaded) } : {}),
            ...(configVersionId ? { params: { configVersionId } } : {}),
        })
        return response
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function searchReportConfigurationMembers(text: string, memberDob: string) {
    try {
        const response = await https.get(v1 + api.REPORT_CONFIGURATION_MEMBER_SEARCH, {
            params: { text, memberDob }
        })
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getReportConfigurationMember(memberIdEncoded: string) {
    try {
        const response = await https.get(`${v1}${api.REPORT_CONFIGURATION_MEMBER}/${encodeURIComponent(memberIdEncoded)}`)
        return response.data
    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export async function getAppVersions(cb: any) {
    let res = await https.get('api/v1/AppVersions')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getAccountPermissionAction(permissionId: number, cb: any) {
    let res = await https.get(`api/v1/Account/permissions/${permissionId}`)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function setAppReleaseApprovalStatus(data: any, cb: any) {
    let res = await https.post('api/v1/AppVersions/Approval', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getAppReleaseNotes(appVersionId: number, cb: any) {
    let res = await https.get(`api/v1/AppVersions/ReleaseNotes/${appVersionId}`)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getAppVersionHistory(appModuleId: number, cb: any) {
    let res = await https.get(`api/v1/AppVersions/History/${appModuleId}`)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveAppReleaseNotes(data: any, cb: any) {
    let res = await https.post('api/v1/AppVersions/ReleaseNotes', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getStatusOptions() {
    try {
        let response = await https.get(v1 + api.LEGAL_STATUS);
        let newElement = {
            "id": null,
            "name": "Blank"
        };
        response.data.unshift(newElement);
        return response.data;  // Returns an array of status options
    } catch (err) {
        console.error("Error fetching status options:", err);
        return [];
    }
}

export async function getCaseTypeOptions() {
    try {
        let response = await https.get(v1 + api.LEGAL_CASETYPES);
        let newElement = {
            "id": null,
            "name": "Blank"
        };
        response.data.unshift(newElement);
        return response.data;  // Returns an array of case type options
    } catch (err) {
        console.error("Error fetching case type options:", err);
        return [];
    }
}


export async function multi(data: any, cb: any) {
    let res = await https.post(v1 + api.COMPLAINT_MULTI, data, { timeout: 300000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function getAllGrievance(data: any, cb: any) {
    let res = await https.post('api/v1/grievances/GetAllGrievance', data, { timeout: 40000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function canUpdateAssignTo(cb: any) {
    let res = await https.post('api/v1/Employees/CanUpdateAssignTo')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function canResolveComplaint(cb: any) {
    let res = await https.post('api/v1/Employees/CanResolveComplaint')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function getInvoiceFilters(cb: any) {
    let res = await https.get('api/v1/ClientInvoices/GetInvoiceListFilters')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err
            })
        });
    return res;
}

export async function getInvoices(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetInvoices', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function saveInvoice(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/SaveInvoice', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getInvoiceActions(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/GetInvoiceActions/'+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({hasError: true, error: err})
        });
    return res;
}
export async function getAddInvoiceDetailsByType(data: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/GetAddInvoiceDetailsByType', { params: data })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err })
        });
    return res;
}

export async function getInvoiceAuditHistory(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetInvoiceAuditHistory', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getInvoice(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetInvoice', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function deleteInvoice(id: any, cb: any) {
    let res = await https.delete('api/v1/ClientInvoices/Delete/'+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getStatusById(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/ChangeStatus/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}
export async function changeInvoiceStatus(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/ChangeStatus', data, {
        timeout: 50000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getUploadedFiles(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetUploadedFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadUploadedFile(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/DownloadUploadedFile/' + id, {
        responseType: "blob", // Important to receive the response as a Blob
        timeout: 120000
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
            cb({ hasError: true, error: err?.response?.data ?? null })
                }
        });
        });
    return res;
}

export async function downloadRawDataFile(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/DownloadRawDataFile/' + id, {
        responseType: "blob", // Important to receive the response as a Blob
        timeout: 120000
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
            cb({ hasError: true, error: err?.response?.data ?? null })
                }
        });
        });
    return res;
}

export async function generateRawDataFile(id: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GenerateRawDataFile/' + id, null)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function uploadFile(data: any, cb: any) {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("files", data.file);
    formData.append("note", data.note);
    let res = await https.post('api/v1/ClientInvoices/UploadFile', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 50000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getRawDataFiles(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetRawDataFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getSubmittedFiles(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetSubmittedFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}
export async function downloadSubmittedFile(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/DownloadSubmittedFile/' + id, {
        timeout: 50000,
        responseType: "blob", // Important to receive the response as a Blob
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON
                    
                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
            cb({ hasError: true, error: err?.response?.data ?? null })
                }
            });
        });
    return res;
}

export async function getCorrectionTrips(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetCorrectionTrips', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCorrectionTriplegDetails(data: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/CorrectionTriplegDetails', {
        params: data,
        timeout:50000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getCorrectionLookups(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/GetCorrectionLookups/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function saveCorrectionTripLeg(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/SaveCorrectionTripLegs', data, {
        timeout:120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getReimbursementSearchTypes(cb: any) {
    let res = await https.get('api/v1/Reimbursement/GetSearchTypes')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getReimbursementList(data: any, cb: any) {
    let res = await https.post('api/v1/Reimbursement/GetReimbursementList', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getReimbursementDetailById(id:any, cb: any) {
    let res = await https.get('api/v1/Reimbursement/GetReimbursementDetailById?ReimbursementId='+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function updateReimbursement(data: any, cb: any) {
    let res = await https.post('api/v1/Reimbursement/UpdateReimbursement', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getTripComplaints(id: any, cb: any) {
    let res = await https.get('api/v1/complaints?tripId=' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getMPSSImportLookups(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/GetMPSSImportLookups/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err })
        });
    return res;
}

export async function getMpssImportTrips(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetMpssImportTrips', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveMpssImportTrips(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/SaveMPSSImportTripLegs', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getAddressSuggestions(address: any, cb: any) {
    let res = await https.get('api/v1/Address/GetAddressSuggestions?address=' + address)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getAddressSuggestionsV2(address: string) {
    let res = await https.get('api/v1/Address/GetAddressSuggestionsV2?address=' + encodeURIComponent(address))
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getFacilityPlaceDetails(address: string, placeId?: string) {
    const params = new URLSearchParams();
    if (address) params.set("address", address);
    if (placeId) params.set("placeId", placeId);

    let res = await https.get('api/v1/Address/GetFacilityPlaceDetails?' + params.toString())
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getFwaTrips(obj: any, cb: any) {
      let res = await https.post('api/v1/Trips/GetFWATrips', obj)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function cancelFWATrips(data: any, cb: any) {
    try {
         const response = await https.post('api/v1/Trips/DenyFWATrips', data, { timeout: 50000 });
        cb({
            hasError: false,
             data: response.data
        });
    } catch (err) {
        cb({
            hasError: true,
            error: err?.response?.data ?? { message: "Unknown error occurred" }
        });
    }
}


export async function approveFWATrips(data: any, cb: any) {
      let res = await https.post('api/v1/Trips/ApproveFWATrips', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getFWASources(cb: any) {
      let res = await https.get('api/v1/Trips/GetFWASources')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobDenailInvoices(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetInvoices', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function getCobDenialInvoiceFilters(cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/GetInvoiceListFilters')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err
            })
        });
    return res;
}

export async function saveCobDenialInvoice(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/SaveInvoice', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobDenialInvoice(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/GetInvoice/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function deleteCobDenialInvoice(id: any, cb: any) {
    let res = await https.delete('api/v1/CobDenialInvoices/Delete/'+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getCobDenialInvoiceAuditHistory(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetInvoiceAuditHistory', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function generateCobDenialRawDataFile(id: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GenerateRawDataFile/' + id, {})
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getCobDenialRawDataFiles(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetRawDataFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadCobDenialRawDataFile(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/DownloadRawDataFile/' + id, {
        responseType: "blob", // Important to receive the response as a Blob
        timeout: 120000
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text: any) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
            cb({ hasError: true, error: err?.response?.data ?? null })
                }
        });
        });
    return res;
}

export async function getCobDenialInvoiceActions(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/GetInvoiceActions/'+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({hasError: true, error: err})
        });
    return res;
}

export async function getPDRCaseImportLookups(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/GetImportLookups/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err })
        });
    return res;
}

export async function getCobDenialImportTrips(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetImportTrips', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveCobDenialImportTrips(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/SaveImportTripLegs', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobDenialPaymentFiles(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetPaymentFiles', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function uploadCobDenialPaymentFile(data: any, cb: any) {
    const formData = new FormData();
    formData.append("clientId", data.clientId);
    formData.append("files", data.file);
    formData.append("invoiceTypeId", data.invoiceTypeId);
    let res = await https.post('api/v1/CobDenialInvoices/UploadPaymentFile', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobDenialInvoiceStatusById(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/ChangeStatus/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function changeCobDenialInvoiceStatus(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/ChangeStatus', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobDenialSubmittedFiles(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/GetSubmittedFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadCobDenialSubmittedFile(id: any, cb: any) {
    let res = await https.get('api/v1/CobDenialInvoices/DownloadSubmittedFile/' + id, {
        timeout: 50000,
        responseType: "blob", // Important to receive the response as a Blob
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text: any) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
                    cb({ hasError: true, error: err?.response?.data ?? null })
                }
            });
        });
    return res;
}

export async function submitCobDenialInvoice(data: any, cb: any) {
    let res = await https.post('api/v1/CobDenialInvoices/SubmitInvoice', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.rePsponse?.data ?? null })
        });
    return res;
}

export async function getRetractionRequestLookups(id: any, cb: any) {
    let res = await https.get('api/v1/VendorInvoices/GetRequestLookups/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getRequestTriplegs(data: any, cb: any) {
    let res = await https.post('api/v1/VendorInvoices/GetRequestTripLegs', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveRetractionRequestForm(data: any, cb: any) {
    let res = await https.post('api/v1/VendorInvoices/SaveRequestTripLegs', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function deleteRetractionRequest(id: any, cb: any) {
    let res = await https.delete('api/v1/VendorInvoices/DeleteRequestTripLegs/'+id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function saveApprovalRequestForm(data: any, cb: any) {
    let res = await https.post('api/v1/VendorInvoices/SaveApprovalRequestTripLegs', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getClientInvoiceCorrectionAuditHistory(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetCorrectionAuditHistory', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getReportFilterList(cb:any) {
    let res = await https.get('api/v1/Complaints/getfilterlist')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getReportData(data: any, cb: any) {
    let res = await https.post('api/v1/Complaints/GetReports', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function exportReportData(data: any, cb: any) {
    let res = await https.post('api/v1/Complaints/ExportRecords', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getBusPassRequest(data: any, cb: any) {
    let res = await https.post('api/v1/BusPass/GetBusPassRequest', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getMemberPassTypeFiles(data: any, cb: any) {
    let res = await https.post('api/v1/BusPass/GetMemberPassTypeFiles', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getPassFormatRules(cb: any) {
    let res = await https.post('api/v1/BusPass/GetPassFormatRules', {}, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function exportBusPassRecords(data: any, cb: any) {
    let res = await https.post('api/v1/BusPass/ExportBusPassRecords', data, {
        timeout: 60000,
        responseType: "blob"
    })
        .then(async (response) => {
            const contentType = response.headers?.["content-type"] ?? "";

            if (contentType.includes("application/json")) {
                const text = await response.data.text();
                return cb(JSON.parse(text));
            }

            const contentDisposition = response.headers?.["content-disposition"] ?? "";
            const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);
            const fileName = fileNameMatch?.[1] ? decodeURIComponent(fileNameMatch[1]) : "BusPassGenerationReport.xlsx";

            return cb({
                file: response.data,
                fileName
            });
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadBusPassMailMerge(data: any, cb: any) {
    let res = await https.post('api/v1/BusPass/DownloadBusPassMailMerge', data, {
        timeout: 60000,
        responseType: "blob"
    })
        .then(async (response) => {
            const contentType = response.headers?.["content-type"] ?? "";

            if (contentType.includes("application/json")) {
                const text = await response.data.text();
                return cb(JSON.parse(text));
            }

            const contentDisposition = response.headers?.["content-disposition"] ?? "";
            const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);
            const fileName = fileNameMatch?.[1] ? decodeURIComponent(fileNameMatch[1]) : "BusPassMailMerge.pdf";

            return cb({
                file: response.data,
                fileName
            });
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function generateBusPass(data: BusPassReportFormValues) {
    try {
        const response = await https.post('api/v1/BusPass/GenerateBusPass', data, {
            timeout: 60000
        });
        return response.data;
    } catch (err: any) {
        const errorPayload = err?.response?.data ?? err;
        throw errorPayload;
    }
}

export async function updateAppointmentTime(data: UpdateAppointmentTimeFormValues) {
    const TIME_FORMAT = 'HH:mm';
    const storedUserName = (() => {
        try {
            return JSON.parse(window.localStorage.getItem('userData') ?? '{}')?.userName ?? '';
        } catch {
            return '';
        }
    })();

    const payload = {
        newPickupTime: data.newPickupTime ? data.newPickupTime.format(TIME_FORMAT) : '',
        standingOrderId: data.standingOrderId ?? '',
        ctcTripId: data.ctcTripId ?? '',
        userName: data.username ?? storedUserName ?? '',
    };

    try {
        const response = await https.post(
            'api/v1/Complaints/UpdateStandingOrderPickupTime',
            payload,
            { timeout: 60000 }
        );
        return response.data;
    } catch (err: any) {
        const errorPayload = err?.response?.data ?? err;
        throw errorPayload;
    }
}

export async function getMemberAddressList(data: any, cb: any) {
    let res = await https.post('/api/v1/MemberAddress/MemberAddressSearch', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}
export async function updateMemberAddressStatus(data: any, cb: any) {
    let res = await https.post('/api/v1/MemberAddress/UpdateMemberAddressStatus', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function addOrUpdateMemberAddress(data: any, cb: any) {
    let res = await https.post('/api/v1/MemberAddress/AddOrUpdateMemberAddress', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function get835PaymentFiles(data: any, cb: any) {
    let res = await https.post('api/v1/Payment835Files/GetFiles', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function uploadPayment835File(data: any, cb: any) {
    const formData = new FormData();
    formData.append("clientId", data.clientId);
    formData.append("paymentFile", data.paymentFile);


    if (data.additionalFiles && data.additionalFiles.length > 0) {
        data.additionalFiles.forEach((fileObj: any) => {
            formData.append("additionalFiles", fileObj.originFileObj);
        });
    }

    let res = await https.post('api/v1/Payment835Files/UploadFile', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 600000 // 10 minutes
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getPayment835FileDetails(id: any, cb: any) {
    let res = await https.get('api/v1/Payment835Files/GetFileDetail/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getPayment835UploadedFiles(data: any, cb: any) {
    let res = await https.post('api/v1/Payment835Files/GetUploadedFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadPayment835File(data: any, cb: any) {
    let res = await https.post('api/v1/Payment835Files/DownloadFile', data, {
        timeout: 600000,
        responseType: "blob", // Important to receive the response as a Blob
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text: any) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
            cb({ hasError: true, error: err?.response?.data ?? null })
                }
            });
        });
    return res;
}

export async function savePayment835FileNote(data: any, cb: any) {
    let res = await https.post('api/v1/Payment835Files/SaveNote', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getPayment835FileAuditHistory(data: any, cb: any) {
    let res = await https.post('api/v1/Payment835Files/GetAuditHistory', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

// Start:  Below are api calls for batch upload complaints
export async function downloadComplaintBatchTemplate() {
    const url = `api/v1/complaints/DownloadBatchTemplate`;

    return https.get(url, {
        responseType: "blob",
        timeout: 120000
    });
}

export async function uploadComplaintBatchTemplate(file: File, hasHeaderRow: boolean = true) {
    const formData = new FormData();
    formData.append("file", file);

    return https.post(`api/v1/complaints/UploadBatchTemplate?hasHeaderRow=${hasHeaderRow}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000
    });
}

export async function validateComplaintBatchTemplate(file: File, hasHeaderRow: boolean = true) {
    const formData = new FormData();
    formData.append("file", file);

    return https.post(`api/v1/complaints/ValidateBatchTemplate?hasHeaderRow=${hasHeaderRow}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000
    });
}


export async function getCalculationBreakdownForCCAHIncentive(invoiceNumber: string, callback: Function) {
    let res = await https.get('api/v1/ClientInvoices/GetCalculationBreakdownForCCAHIncentive/' + invoiceNumber)
        .then((response) => {
            return callback(response.data)
        })
        .catch((err) => {
            callback({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveCCAHIncentiveCalculation(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/SaveCCAHIncentiveCalculation', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCCAHCalculationDetails(clientInvoiceSId: number, callback: Function) {
    let res = await https.get('api/v1/ClientInvoices/GetCCAHCalculationDetails/' + clientInvoiceSId)
        .then((response) => {
            return callback(response.data)
        })
        .catch((err) => {
            callback({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getPayment835FileStatuses() {
    let res = await https.get('api/v1/Payment835Files/GetStatuses')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function generateClientInvoiceSubmissionFiles(id: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GenerateSubmissionFiles/' + id, null)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({ hasError: true, error: err?.response?.data ?? null })
        });
    return res;
}

export async function getClientInvoiceSubmissionFiles(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetSubmissionFiles', data)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadClientInvoiceSubmissionFile(id: any, cb: any) {
    let res = await https.get('api/v1/ClientInvoices/DownloadSubmissionFile/' + id, {
        responseType: "blob", // Important to receive the response as a Blob
        timeout: 120000
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            errorBlob.text().then((text) => {
                try {
                    const json = JSON.parse(text); // Parse text to JSON

                    cb({ hasError: true, error: json ?? null })
                } catch (parseError) {
                    cb({ hasError: true, error: err?.response?.data ?? null })
                }
            });
        });
    return res;
}

export async function importBusPassRecords(data: any, cb: any) {
    const formData = new FormData();
    formData.append("clientId", data.clientId);
    formData.append("clientInvoiceSId", data.clientInvoiceSId);
    formData.append("file", data.file);

    let res = await https.post('api/v1/ClientInvoices/ImportBusPassRecords', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function saveBusPassImportedRecords(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/SaveBusPassImportedRecords', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getVendorInvoicePaymentFiles(data: any, cb: any) {
    let res = await https.post('api/v1/VendorInvoices/GetPaymentFiles', data, { timeout: 60000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb('error')
        });
    return res;
}

export async function uploadReviewVendorInvoicePaymentFile(data: any, cb: any) {
    const formData = new FormData();
    if (data?.file) {
        formData.append("file", data.file);
    }

    let res = await https.post('api/v1/VendorInvoices/UploadReviewPaymentFile', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 180000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}


export async function getVendorInvoicePaymentFileDetails(id: any, cb: any) {
    let res = await https.get('api/v1/VendorInvoices/GetPaymentFileDetails/' + id)
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}


export async function saveVendorInvoicePaymentFile(data: any, cb: any) {
    const formData = new FormData();
    if (data?.file) {
        formData.append("file", data.file);
    }
    formData.append("rowsJson", JSON.stringify(data?.rows ?? []));

    let res = await https.post('api/v1/VendorInvoices/SavePaymentFile', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 600000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function downloadVendorInvoicePaymentFile(id: any, cb: any) {
    let res = await https.get('api/v1/VendorInvoices/DownloadPaymentFile/' + id, {
        responseType: "blob",
        timeout: 180000
    })
        .then((response) => {
            return cb(response)
        })
        .catch((err) => {
            const errorBlob = err?.response?.data;
            if (errorBlob && typeof errorBlob.text === "function") {
                errorBlob.text().then((text: any) => {
                    try {
                        const json = JSON.parse(text);
                        cb({ hasError: true, error: json ?? null })
                    } catch (parseError) {
                        cb({ hasError: true, error: { messages: [ { description: text || "Unable to download file." } ] } })
                    }
                });
            } else {
                cb({ hasError: true, error: { messages: [ { description: "Unable to download file." } ] } })
            }
        });
    return res;
}

export async function getIEHPReplacementClaims(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/GetIEHPReplacementClaims', data, {
        timeout: 60000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function excludeReplacementClaims(data: any, cb: any) {
    let res = await https.post('api/v1/ClientInvoices/ExcludeReplacementClaims', data, {
        timeout: 120000
    })
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err?.response?.data ?? null
            })
        });
    return res;
}

export async function getCobPayerFilters(cb: any) {
    let res = await https.get('api/v1/CobPayers/GetPayerListFilters')
        .then((response) => {
            return cb(response.data)
        })
        .catch((err) => {
            cb({
                hasError: true,
                error: err
            })
        });
    return res;
}

export async function getCobPayers(data: any, cb: any) {
    let res = await https.post('api/v1/CobPayers/GetPayers', data, { timeout: 50000 })
        .then((response) => {
            return cb(response.data)
        })
        .catch(() => {
            cb('error')
        });
    return res;
}

export async function getCobPayer(id: number, cb: any) {
    let res = await https.get(`api/v1/CobPayers/GetPayer/${id}`)
        .then((response) => {
            return cb({ hasError: false, data: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to load COB Payer.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

export async function getCobPayerAuditHistory(id: number, cb: any) {
    let res = await https.get(`api/v1/CobPayers/GetPayerAuditHistory/${id}`)
        .then((response) => {
            return cb({ hasError: false, data: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to load COB Payer audit history.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

export async function getCobPayerActions(id: number, cb: any) {
    let res = await https.get(`api/v1/CobPayers/GetPayerActions/${id}`)
        .then((response) => {
            return cb({ hasError: false, data: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to load COB Payer actions.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

export async function deleteCobPayer(id: number, cb: any) {
    let res = await https.delete(`api/v1/CobPayers/DeletePayer/${id}`)
        .then((response) => {
            return cb({ hasError: false, data: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to delete COB Payer.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

export async function updateCobPayer(id: number, data: any, cb: any) {
    let res = await https.put(`api/v1/CobPayers/UpdatePayer/${id}`, data)
        .then((response) => {
            return cb({ hasError: false, id: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to update COB Payer.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

export async function saveCobPayer(data: any, cb: any) {
    let res = await https.post('api/v1/CobPayers/SavePayer', data)
        .then((response) => {
            return cb({ hasError: false, id: response.data })
        })
        .catch((err) => {
            const responseData = err?.response?.data;
            const message = responseData?.messages?.[ 0 ]?.description
                ?? responseData?.detail
                ?? responseData?.title
                ?? "Unable to save COB Payer.";
            return cb({ hasError: true, error: message })
        });
    return res;
}

function cobPayerApprovalResult(cb: any) {
    return (response: any) => cb({ hasError: false, data: response.data });
}

function cobPayerErrorMessage(value: any): string | null {
    if (typeof value === "string") return value;
    if (Array.isArray(value)) {
        const messages = value.map(cobPayerErrorMessage).filter(Boolean);
        return messages.length ? messages.join(" ") : null;
    }
    if (value && typeof value === "object") {
        return cobPayerErrorMessage(value.description)
            ?? cobPayerErrorMessage(value.message)
            ?? cobPayerErrorMessage(value.detail)
            ?? cobPayerErrorMessage(value.title);
    }
    return null;
}

function cobPayerApprovalError(cb: any) {
    return (err: any) => {
        const responseData = err?.response?.data;
        cb({
            hasError: true,
            error: cobPayerErrorMessage(responseData?.messages)
                ?? cobPayerErrorMessage(responseData)
                ?? "Unable to process COB Payer change request."
        });
    };
}

export async function submitCobPayerChangeRequest(id: number, data: any, cb: any) {
    return https.post(`api/v1/CobPayers/SubmitChangeRequest/${id}`, data)
        .then(cobPayerApprovalResult(cb)).catch(cobPayerApprovalError(cb));
}

export async function saveAndApproveCobPayerChangeRequest(id: number, data: any, cb: any) {
    return https.post(`api/v1/CobPayers/SaveAndApproveChangeRequest/${id}`, data)
        .then(cobPayerApprovalResult(cb)).catch(cobPayerApprovalError(cb));
}

export async function getCobPayerChangeRequests(id: number, cb: any) {
    return https.get(`api/v1/CobPayers/GetChangeRequests/${id}`)
        .then(cobPayerApprovalResult(cb)).catch(cobPayerApprovalError(cb));
}

export async function processCobPayerChangeRequest(id: number, action: number, rejectedReason: string | null, cb: any) {
    return https.post(`api/v1/CobPayers/ProcessChangeRequest/${id}`, { action, rejectedReason })
        .then(cobPayerApprovalResult(cb)).catch(cobPayerApprovalError(cb));
}

export async function saveCobPayerAddressOtherInformation(id: number, data: any, cb: any) {
    return https.put(`api/v1/CobPayers/SaveAddressOtherInformation/${id}`, data)
        .then(cobPayerApprovalResult(cb)).catch(cobPayerApprovalError(cb));
}

export async function getFacilityLookups() {
    let res = await https.get('api/v1/Facilities/GetFacilityLookups')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getFacilityServiceTypes() {
    let res = await https.get('api/v1/Facilities/GetFacilityServiceTypes')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getGoogleMapsApiKey() {
    let res = await https.get('api/v1/Address/GetGoogleMapsApiKey')
        .then((response) => {
            return response.data
        })
        .catch((err) => {
            console.log(err)
        });
    return res;
}

export async function getFacilities(data: any) {
    try {
        const response = await https.post('api/v1/Facilities/GetFacilities', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function searchFacility(data: any) {
    try {
        const response = await https.post('api/v1/FacilitySearch/SearchFacility', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function searchBscaCbasFacilities(data: any) {
    try {
        const response = await https.post('api/v1/FacilitySearch/SearchBscaCbasFacilities', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function searchLacCbsaFacilities(data: any) {
    try {
        const response = await https.post('api/v1/FacilitySearch/SearchLacCbsaFacilities', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function searchBscaUrgentCareFacilities(data: any) {
    try {
        const response = await https.post('api/v1/FacilitySearch/SearchBscaUrgentCareFacilities', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function getFacility(id: number) {
    try {
        const response = await https.get(`api/v1/Facilities/GetFacility/${id}`);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function addFacility(data: any) {
    try {
        const response = await https.post('api/v1/Facilities/AddFacility', data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export async function updateFacility(id: number, data: any) {
    try {
        const response = await https.put(`api/v1/Facilities/UpdateFacility/${id}`, data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}
